import { MenuAction } from '@shared/interfaces/header/menu-action';
import { Check, List, Reply, Trash } from 'lucide-angular';

export const dashboardActionMenu: MenuAction[] = [
  {
    id: 'reply',
    title: 'dashboard.reply.title',
    icon: Reply,
  },
  {
    id: 'complete',
    title: 'dashboard.complete.title',
    icon: Check,
  },
  {
    id: 'list',
    title: 'dashboard.list.title',
    icon: List,
  },
  {
    id: 'remove',
    title: 'dashboard.remove.title',
    icon: Trash,
  },
];
